export const customRequestModalSkillsCount = 10;